var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.options.disabled)?_c('router-link',{class:_vm.computedClass,attrs:{"to":Object.assign({}, _vm.routerObject)}},[_vm._v("\n  "+_vm._s(_vm.options.transform(_vm.value || _vm.options.value))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }